import { EChartsAdapter } from '../adapters/echarts/EChartsAdapter';
import { getDefaultLibrary } from './ChartConfig';
export class ChartFactory {
    static createAdapter(library) {
        const lib = library ?? getDefaultLibrary();
        if (lib === 'echarts') {
            return new EChartsAdapter();
        }
        throw new Error(`Biblioteca não suportada: ${lib}`);
    }
}
